import validator from 'validator';
import { checkIfValidUnivName } from '../../auth/validationV2';

import { ajax } from '../../utils/fetch';

import { statusMsg, sanitizeName } from '../../utils/utils';

import PopupFactory from '../body/blocks/popup/popupFactory';

const templateLoginSignup = document.createElement('template');

templateLoginSignup.innerHTML = `<a  class="ml-a link link-item login">Login</a>
                                 <a  class="link link-btn signup">Sign Up</a>`;

const templateLandingHeader = document.createElement('template');

templateLandingHeader.innerHTML = `<header class="header container mh-a" >
                                    <span class="au-dot"></span>
                                    <div class="brand-logo">
                                        <img class= "landing-logo" src="" alt="brand logo" onerror="this.src='https://storage.staging.adaptiveu.io/files/img/fF1z88vE7llG/icon128-copy.png'">
                                        <input type="file" name="logo-upload" id="logo-upload">
                                        <label for="logo-upload" class="editable" ><img src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/camera-icon.svg"  alt=""></label>
                                    </div>

                                    <div class="title editable mr-a"><textarea class="title"  data-placeholder ="Brand Name"></textarea></div>

                                    <a href="" class="link link-item">Courses</a>

                                </header>`;

export default class LandingHeader extends HTMLElement {
  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  static get observedAttributes() {
    return ['semanticname', 'mode'];
  }

  connectedCallback() {
    this.appendChild(templateLandingHeader.content.cloneNode(true));
    this._bindPasteEvent();
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal)
      this._buildHeader(this._name, this._image);

    if (name === 'mode' && newVal)
      if (newVal === 'edit') this._bindEvents();
      else {
        this.querySelector('.header').appendChild(
          templateLoginSignup.content.cloneNode(true)
        );
        this._bindLoginSignupClick();
      }
    if (name === 'upload' && newVal) this._afterUpload(newVal);
  }

  _buildHeader(name, image) {
    if (name)
      this.querySelector('.title').querySelector('textarea').value = name;

    if (image)
      this.querySelector('.brand-logo > img').setAttribute('src', image);
    else
      this.querySelector('.brand-logo > img').setAttribute(
        'src',
        'https://storage.staging.adaptiveu.io/files/img/fF1z88vE7llG/icon128-copy.png'
      );
  }

  _bindPasteEvent() {
    // console.log(this.getAttribute('mode'));
    // const contenteditable = document.querySelector('textarea');
    // contenteditable.addEventListener('paste', e => {
    //   e.preventDefault();
    //   const text = e.clipboardData.getData('text/plain');
    //   const [start, end] = [e.target.selectionStart, e.target.selectionEnd];
    //   e.target.setRangeText(text.trim().substring(0, 100), start, end);
    //   // document.execCommand('insertText', false, text.trim().substring(0, 100));
    // });
  }

  _bindLoginSignupClick() {
    const url = this._removeTrailingSlashes(window.location.href);

    this.querySelector('.login').addEventListener('click', e => {
      window.location.href = `/login?referrer=${url}`;
    });
    this.querySelector('.signup').addEventListener('click', e => {
      window.location.href = `/signup?referrer=${url}`;
    });
  }

  _removeTrailingSlashes(url) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }

  _bindEvents() {
    this.querySelector('.title')
      .querySelector('textarea')
      .addEventListener('blur', async e => {
        try {
          const updatedUnivName = this.querySelector('.title').querySelector(
            'textarea'
          ).value;

          if (updatedUnivName !== this._name) {
            const validUnivResponse = checkIfValidUnivName(updatedUnivName);

            if (validUnivResponse && validUnivResponse.status) {
              // statusMsg('Saving ...', 'warning', this);

              const univDTO = {
                name: sanitizeName(updatedUnivName),
                semanticName: window.univ.semanticName
              };

              const response = await this._updateName(univDTO);
              if (response) {
                if (response.status) {
                  this._name = updatedUnivName;
                  statusMsg(
                    'University name updated successfully',
                    'success',
                    this
                  );
                  return;
                }
                if (response.msg) statusMsg(response.msg, 'warning', this);
              }
              return;
            }

            statusMsg(
              validUnivResponse.message
                ? validUnivResponse.message
                : 'Invalid university name',
              'warning',
              this
            );
          } else console.log('Same university name');
        } catch (error) {
          console.error(`Error while title blur event :: ${error.message}`);
        }
      });

    this.querySelector('.title')
      .querySelector('textarea')
      .addEventListener('keydown', e => {
        try {
          const name = this.querySelector('.title')
            .querySelector('textarea')
            .value.trim();
          if (e.metaKey === true || e.key.length !== 1) return true;

          if (validator.isAscii(e.key) && name.length > 100) {
            e.preventDefault();
            statusMsg('You reached max 100 characters', 'warning', this);
            return false;
          }
        } catch (error) {
          console.error(`Error while title keydown :: ${error.message}`);
        }
        return true;
      });

    this.querySelector('.title')
      .querySelector('textarea')
      .addEventListener('paste', e => {
        try {
          const name = this.querySelector('.title')
            .querySelector('textarea')
            .value.trim();
          if (name.length > 100) {
            e.preventDefault();
            statusMsg('You reached max 100 characters', 'warning', this);
            return false;
          }
        } catch (error) {
          console.error(`Error while title paste :: ${error.message}`);
        }
        return true;
      });

    this.querySelector('#logo-upload').addEventListener('change', async e => {
      try {
        let cropPopup = this.querySelector('au-crop');

        const pathQueryMap = {
          pathMap: this._pathMap,
          queryMap: this._queryMap,
          historyState: this._historyState
        };
        const cropPopupFactory = new PopupFactory('crop', pathQueryMap);
        if (!cropPopup) {
          cropPopup = cropPopupFactory.createComponent();
          this.appendChild(cropPopup);
        }
        cropPopup._file = e;
        cropPopup._minHeight = this.querySelector('.brand-logo').offsetHeight;
        cropPopup._minWidth = this.querySelector('.brand-logo').offsetWidth;
        cropPopup._componentName = 'au-landing-header';

        cropPopupFactory.setAttributes(
          cropPopup,
          this.getAttribute('semanticname')
        );

        cropPopup.addEventListener('afterUpload', event => {
          this._afterUpload(event.detail.link);
        });

        cropPopup.addEventListener('statusMsg', event => {
          statusMsg(event.detail.msg, event.detail.status, this);
        });
        cropPopup.addEventListener('removeFile', () => {
          this.querySelector('.brand-logo').querySelector('input').value = '';
        });
      } catch (error) {
        console.error(`Error while logo upload :: ${error.message}`);
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async _updateName(univDTO) {
    try {
      const univNameRequest = {};

      univNameRequest.contentType = 'application/json; charset=utf-8';
      univNameRequest.method = 'PATCH';
      univNameRequest.url = `/api/v1/university/${window.univ.semanticName}/name`;
      univNameRequest.body = univDTO;

      return await ajax(univNameRequest);
    } catch (e) {
      console.error(`Error while updating name ${e}`);
    }
    return {};
  }

  async _afterUpload(link) {
    try {
      const univDetails = {};
      univDetails.semanticName = this.getAttribute('semanticname');
      univDetails.image = link;

      const request = {};

      request.contentType = 'application/json; charset=utf-8';

      request.method = 'PATCH';

      request.url = `/api/v1/university/${this.getAttribute(
        'semanticname'
      )}/image`;

      request.body = {};

      request.body = univDetails;

      const response = await ajax(request);
      if (response) {
        if (response.status) {
          this.querySelector('.landing-logo').setAttribute('src', link);
        } else {
          statusMsg(response.msg, 'warning', this);
        }
      }
    } catch (e) {
      console.error(`Error while landing logo after upload  :: ${e.message}`);
    }
  }
}
